import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import KeyDecisionAnswer from "./KeyDecisionAnswer";
import KeyDecisionDefinition from "./KeyDecisionDefinition";

export default class KeyDecision {
    /**
     * @constructor
     * @param {KeyDecisionDefinition} keyDecisionDefinition 
     * @param {Content} content 
     * @param {NGTScenarioPlayer} contentPlayer 
     */
    constructor(keyDecisionDefinition, content, contentPlayer) {
        this._keyDecisionDefinition = keyDecisionDefinition;
        this._content = content;
        this._contentPlayer = contentPlayer;
        this._optimalAnswers = [];
        this._playerAnswers = [];
    }

    get id() {
        return this._keyDecisionDefinition?.id;
    }

    get chapter() {
        return this._keyDecisionDefinition?.chapter;
    }

    get arc() {
        return this._keyDecisionDefinition?.arc;
    }

    get backgroundImageId() {
        return this._keyDecisionDefinition?.backgroundImageId;
    }

    get content() {
        return this._content;
    }

    get contentPlayer() {
        return this._contentPlayer;
    }

    get baseLpKey() {
        return `keyDecisions.${this.id}`;
    }

    get descriptionLpKey() {
        return `${this.baseLpKey}.descriptionText`;
    }
    
    get actionNeededLpKey() {
        return `${this.baseLpKey}.actionNeededText`;
    }

    /**
     * @returns {Array<KeyDecisionAnswer>}
     */
    get optimalAnswers() {
        return this._optimalAnswers;
    }
    
    /**
     * @returns {Array<KeyDecisionAnswer>}
     */
    get playerAnswers() {
        return this._playerAnswers;
    }

    set optimalAnswers(value) {
        this._optimalAnswers = value;
    }
    
    set playerAnswers(value) {
        this._playerAnswers = value;
    }

    /**
     * @param {KeyDecisionAnswer} keyDecision 
     */
    addOptimalAnswer(keyDecisionAnswer) {
        this._optimalAnswers.push(keyDecisionAnswer);
    }

    /**
     * @param {KeyDecisionAnswer} keyDecision 
     */
    addPlayerAnswer(keyDecisionAnswer) {
        this._playerAnswers.push(keyDecisionAnswer);
    }
}